










































import { TwoOfThreeTextQuestionSpec } from '@/model/question'
import StandardLayoutQuestion from '@/components/question/layout/StandardLayoutQuestion.vue'
import QuestionHeader from '@/components/misc/QuestionHeader.vue'
import QuestionText from '@/components/misc/QuestionText.vue'
import MultipleTextInput from '@/components/inputs/MultipleTextInput.vue'
import QuestionNotes from '@/components/misc/QuestionNotes.vue'
import MultipleAnswerStats from '@/components/stats/MultipleAnswerStats.vue'
import { BaseQuestion } from '@/components/question/baseQuestion'

export default BaseQuestion<TwoOfThreeTextQuestionSpec>().extend({
  name: 'TwoOfThreeQuestion',
  components: {
    StandardLayoutQuestion,
    MultipleTextInput,
    MultipleAnswerStats,
    QuestionNotes,
    QuestionText,
    QuestionHeader
  }
})
